import React, { useState } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import api from '../../functions/api';
import '../../styles/Forms.css'
import { useToast } from '../ToastProvider';
import { ReactComponent as IconClose } from "../../assets/icons/icon-close.svg";

const ChangePasswordForm = ({ username, show, handleClose }) => {
  const { showSuccess, showError } = useToast();
  const initialForm = {
    current: '',
    new1: '',
    new2: ''
  };

  /* ---------- formData ---------- */
  const [formData, setFormData] = useState(initialForm);
  const resetForm = () => setFormData(initialForm);

  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.new1 !== formData.new2) {
      showError('Las nuevas contraseñas no coinciden');
      return;
    }
    try {
      setLoading(true);
      const token = localStorage.getItem('access_token');
      await api.post(
        '/auth/users/change-password',
        { username, password: formData.current, new_password: formData.new1 },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      showSuccess('Contraseña actualizada');
      handleClose();
      setFormData({ current: '', new1: '', new2: '' });
    } catch (err) {
      console.error(err);
      showError('No se pudo cambiar la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} onExited={resetForm} centered backdrop="static" dialogClassName="basic-modal">
      <Modal.Header closeButton={false}>
        <Modal.Title>Cambiar contraseña</Modal.Title>
        <button
          type="button"
          onClick={handleClose}
          aria-label="Cerrar modal"
          className="btn-reset ms-auto"   // define estilo a tu gusto
        >
          <IconClose className="mc-link__icon secondary" />
        </button>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Contraseña actual</Form.Label>
            <Form.Control
              type="password"
              name="current"
              value={formData.current}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Nueva contraseña</Form.Label>
            <Form.Control
              type="password"
              name="new1"
              value={formData.new1}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Repetir nueva contraseña</Form.Label>
            <Form.Control
              type="password"
              name="new2"
              value={formData.new2}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <div className="d-grid">
            <Button variant="primary" type="submit" disabled={loading} className='btn-dark'>
              {loading ? <Spinner size="sm" /> : 'Guardar'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ChangePasswordForm;
